<template>
  <aside :class="{ collapsed: isCollapsed }">
    <div class="logo">
      <i class="fas fa-chart-line"></i>
      <span v-if="!isCollapsed">额度管家</span>
    </div>
    <nav class="sidebar-nav">
      <router-link
        v-for="item in menuItems"
        :key="item.path"
        :to="item.path"
        class="nav-link"
        :class="{ active: isActive(item.path) }"
      >
        <i :class="item.icon"></i>
        <span v-if="!isCollapsed">{{ item.name }}</span>
      </router-link>
    </nav>
  </aside>
</template>

<script>
export default {
  props: {
    isCollapsed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menuItems: [
        { name: "主页", path: "/admin", icon: "fas fa-home" },
        { name: "表单", path: "/form", icon: "fas fa-file-alt" },
        { name: "二维码", path: "/qrcode", icon: "fas fa-qrcode" },
        { name: "还款期数", path: "/repayment-periods", icon: "fas fa-calendar-alt" },
        { name: "行业/职位", path: "/industry-position", icon: "fas fa-briefcase" },
        { name: "贷款用途", path: "/loan-purpose", icon: "fas fa-hand-holding-usd" },
        { name: "人物关系", path: "/personal-relationships", icon: "fas fa-users" },
        { name: "参数配置", path: "/parameter-configurations", icon: "fas fa-cog" },
      ],
    };
  },
  methods: {
    isActive(path) {
      return this.$route.path === path;
    },
  },
};
</script>

<style scoped>
aside {
  width: 260px;
  background: linear-gradient(180deg, #0f172a 0%, #0a0f1c 100%);
  color: #cbd5e1;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow-y: auto;
  flex-shrink: 0;           /* 防止侧边栏被压缩 */
  height: 100vh;            /* 撑满视口高度 */
  border-right: 1px solid #1e2937;
}

/* 收起状态宽度 */
aside.collapsed {
  width: 72px;
}

/* Logo 区域 */
.logo {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 24px 20px;
  border-bottom: 1px solid #1e2937;
  margin-bottom: 16px;
}

.logo i {
  font-size: 28px;
  color: #60a5fa;
}

.logo span {
  font-size: 18px;
  font-weight: 700;
  background: linear-gradient(135deg, #60a5fa, #a855f7);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

/* 导航菜单 */
.sidebar-nav {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0 12px;
}

.nav-link {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 16px;
  border-radius: 12px;
  color: #cbd5e1;
  text-decoration: none;
  transition: all 0.2s;
  font-size: 15px;
  font-weight: 500;
}

.nav-link i {
  width: 24px;
  font-size: 20px;
}

.nav-link:hover {
  background: rgba(255, 255, 255, 0.05);
  color: white;
}

.nav-link.active {
  background: linear-gradient(90deg, #3b82f6, #1e40af);
  color: white;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

/* 收起状态样式 */
aside.collapsed .nav-link {
  justify-content: center;
  padding: 12px 0;
}

aside.collapsed .nav-link span {
  display: none;
}

aside.collapsed .logo {
  justify-content: center;
  padding: 24px 0;
}

aside.collapsed .logo span {
  display: none;
}

/* 手机端隐藏（App.vue 中手机端已经使用 BottomNav，侧边栏不再出现） */
@media (max-width: 768px) {
  aside {
    display: none;
  }
}
</style>